export default __webpack_public_path__ + "static/media/bg-4.daa67fa1.jpg";